// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ExternalImportRateLimitOptions,
  ExternalImportRateLimitOptionsFromJSON,
  ExternalImportRateLimitOptionsToJSON,
} from "./";

/**
 * Per-import behavioural options
 * @export
 * @interface ExternalImportOptions
 */
export interface ExternalImportOptions {
  /**
   * Skip intra-import duplicate test cases (TF-IDF + cosine similarity)
   * @type {boolean}
   * @memberof ExternalImportOptions
   */
  skipDuplicates?: boolean;
  /**
   * Cosine similarity cutoff for the duplicate detector (0.4 - 0.9)
   * @type {number}
   * @memberof ExternalImportOptions
   */
  dedupThreshold?: number;
  /**
   * When true, duplicate detection compares test cases only within the same repository path
   * @type {boolean}
   * @memberof ExternalImportOptions
   */
  dedupSameRepositoryOnly?: boolean;
  /**
   * Project user ID to set as the default assignee for imported test plans
   * @type {number}
   * @memberof ExternalImportOptions
   */
  defaultTestPlanAssignee?: number;
  /**
   * Also import source test cases that do not belong to any test plan. They are imported at the top level of the test case repository and are not added to a test plan. Only used by sources where test cases can exist outside a test plan (Azure Test Plans)
   * @type {boolean}
   * @memberof ExternalImportOptions
   */
  includeUnlinkedTestCases?: boolean;
  /**
   *
   * @type {ExternalImportRateLimitOptions}
   * @memberof ExternalImportOptions
   */
  rateLimits?: ExternalImportRateLimitOptions;
}

export function ExternalImportOptionsFromJSON(
  json: any
): ExternalImportOptions {
  return {
    skipDuplicates: !exists(json, "skip_duplicates")
      ? undefined
      : json["skip_duplicates"],
    dedupThreshold: !exists(json, "dedup_threshold")
      ? undefined
      : json["dedup_threshold"],
    dedupSameRepositoryOnly: !exists(json, "dedup_same_repository_only")
      ? undefined
      : json["dedup_same_repository_only"],
    defaultTestPlanAssignee: !exists(json, "default_test_plan_assignee")
      ? undefined
      : json["default_test_plan_assignee"],
    includeUnlinkedTestCases: !exists(json, "include_unlinked_test_cases")
      ? undefined
      : json["include_unlinked_test_cases"],
    rateLimits: !exists(json, "rate_limits")
      ? undefined
      : ExternalImportRateLimitOptionsFromJSON(json["rate_limits"]),
  };
}

export function ExternalImportOptionsToJSON(
  value?: ExternalImportOptions
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    skip_duplicates: value.skipDuplicates,
    dedup_threshold: value.dedupThreshold,
    dedup_same_repository_only: value.dedupSameRepositoryOnly,
    default_test_plan_assignee: value.defaultTestPlanAssignee,
    include_unlinked_test_cases: value.includeUnlinkedTestCases,
    rate_limits: ExternalImportRateLimitOptionsToJSON(value.rateLimits),
  };
}
